import React from 'react'
import { useTranslation } from 'react-i18next'

import { CustomConfirmDialog } from '../../../../../../components/dialogs'
import { RoleAssignment } from '../../../data'

type Props = {
  onClickHandler: () => void
  role: RoleAssignment['role']
  assignee: RoleAssignment['assignee']
  project: RoleAssignment['project']
  isVisible: boolean
  onhide: () => void
}

export const DeleteAssignee: React.FC<Props> = ({
  onClickHandler,
  isVisible,
  role,
  assignee,
  project,
  onhide,
}) => {
  const { t } = useTranslation()

  const message = (
    <>
      <p>
        {t('members.table.delete.dialog.description', {
          assignee: assignee,
          role: role,
        })}
      </p>
      <strong>{assignee}</strong>
      <br />
      {role}
      <br />
      {project}
    </>
  )
  return (
    <CustomConfirmDialog
      severity="danger"
      isVisible={isVisible}
      header={t('members.table.delete.dialog.title')}
      message={message}
      onHide={onhide}
      onReject={onhide}
      onAccept={onClickHandler}
      rejectLabel={t('members.table.delete.dialog.cancel.label')}
      acceptLabel={t('members.table.delete.dialog.delete.label')}
    />
  )
}
